// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Tooltip_trigger__1MfdX"};